// extracted by mini-css-extract-plugin
module.exports = {"section__title":"SectionTitle_section__title__3l7dl","section__title--content":"SectionTitle_section__title--content__2RDhk"};